module.exports = __webpack_public_path__ + "static/img/0efb5aaba5ce9f9e57b7f8a38e7ace30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_tjsc.png
// module id = ecDV
// module chunks = 1